import React from 'react';
import Hero from './components/faculty-types/Hero';
import Main from './components/faculty-types/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const FacultyTypes = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default FacultyTypes;